// grid landscape style
import { SxProps } from "@mui/system";
import type { ThemeV2 } from "../../../util/types";

export const rowTextStyle = (
  theme: ThemeV2,
  isImageExist: boolean,
): SxProps => {
  return {
    color: theme.tokens.color.action.primary,
    fontWeight: theme.tokens.typography.weight.regular,
    wordWrap: "break-word",
    cursor: "pointer",
    maxWidth: { md: "100%", xs: isImageExist ? "65px" : "100%" },
    textAlign: "end",
  };
};
export const rowLableWraper: SxProps = {
  textAlign: "end",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  minHeight: { md: "60px", xs: "50px" },
  fontSize: { sm: "16px", xs: "14px" },
  fontWeight: 500,
};
